module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJUlEQVQ4y2NgGBTgP5lgOBnwi5n5Pzl4EBkA9M1/cvBwMmBoAwCVK9peWda4VAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_south-ossetia.png
// module id = 1323
// module chunks = 0